import {useState} from "react";

export function useHover(styleOnHover, enabled = true, defaultStyle  = {})
{
    const [style, setStyle] = useState(defaultStyle);

    const onMouseEnter = () => enabled && setStyle(styleOnHover)
    const onMouseLeave = () => enabled && setStyle(defaultStyle)

    return {style, onMouseEnter, onMouseLeave}
}